import React, { useContext } from 'react';
import { isProfileComplete } from '../../util/user';
import { TertiaryButton } from '../Button/Button';
import { CHECKLIST_ID } from '../../forms/ProfileSettingsForm/NavigationBar';
import { navigateTo } from '../../forms/ProfileSettingsForm/helpers';
import { ProfileSettingsContext } from '../../forms/ProfileSettingsForm/ProfileSettingsForm';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../marketplace-custom-config';
import { USER_AVAILABILITY } from '../../forms/ProfileSettingsForm/config';
import ListingStatistics from './ListingStatistics';
import ActionWrapper from './ActionWrapper';

const StatisticsSectionActionsRider = ({ currentUser, currentListing }) => {
    const { handleEditSection, setModalParams } = useContext(ProfileSettingsContext) || {};
    const { uuid: listingId } = currentListing?.id || {};
    const { isPrimaryFieldsComplete } = isProfileComplete(currentUser);
    const { availabilityFirstTimeConfirmed, availabilitySetNotAvailableAt, availability } =
        currentUser?.attributes?.profile?.publicData || {};

    const notAvaiable = availability === RIDER_AVAILABILITY_NOT_AVAILABLE;
    const profileCompleteAndProfileClosed =
        !listingId && isPrimaryFieldsComplete && notAvaiable && availabilitySetNotAvailableAt;
    const profileCompleteWithoutAvailability =
        isPrimaryFieldsComplete && !availabilityFirstTimeConfirmed;

    const editUserAvailability = isConfirm => {
        handleEditSection(USER_AVAILABILITY);
        setModalParams({
            isConfirm,
        });
    };

    if (!isPrimaryFieldsComplete) {
        return (
            <ActionWrapper>
                <TertiaryButton
                    type="button"
                    onClick={e => {
                        window.history.pushState(null, null, `#${CHECKLIST_ID}`);
                        navigateTo(`#${CHECKLIST_ID}`);
                    }}
                >
                    Profil vervollständigen
                </TertiaryButton>
            </ActionWrapper>
        );
    }
    if (profileCompleteWithoutAvailability) {
        return (
            <ActionWrapper>
                <TertiaryButton type="button" onClick={() => editUserAvailability(false)}>
                    Verfügbarkeit hinzufügen
                </TertiaryButton>
            </ActionWrapper>
        );
    }
    if (profileCompleteAndProfileClosed) {
        return (
            <ActionWrapper>
                <TertiaryButton type="button" onClick={() => editUserAvailability(true)}>
                    Verfügbarkeit bestätigen
                </TertiaryButton>
            </ActionWrapper>
        );
    }
    if (listingId) {
        return <ListingStatistics currentListing={currentListing} />;
    }

    return null;
};

export default StatisticsSectionActionsRider;
